import styled from 'styled-components';

import { Button as ToggleButton } from '../../../components/blocks';

type Props = {
  open?: boolean;
};

const Title = styled.p<Props>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spaces.m};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.fontColors.lightgrey};
  line-height: ${({ theme }) => theme.lineHeights.l};
  cursor: pointer;
`;

const Item = styled.li`
  dislay: block;
  list-style: none;
  margin: 0;
  padding: 0;
  border-top: 1px solid ${({ theme }) => theme.borderColors.default};

  & > a {
    display: block;
    cursor: pointer;
    font-size: ${({ theme }) => theme.fontSizes.s};
    padding: ${({ theme }) => `${theme.spaces.m} ${theme.spaces.s}`};
    color: ${({ theme }) => theme.fontColors.grey};
    transition-duration: ${({ theme }) => theme.transitions.normal};

    &:hover {
      color: ${({ theme }) => theme.fontColors.blue};
      padding-left: ${({ theme }) => theme.spaces.m};
    }
  }

  &.h3 {
    padding-left: ${({ theme }) => theme.spaces.xl};

    a {
      color: ${({ theme }) => theme.fontColors.lightgrey};
    }
  }
`;

const Button = styled(ToggleButton)<Props>`
  background: none;
  border: 0;
  padding: ${({ theme }) => theme.spaces.m} 0;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  transition-duration: ${({ theme }) => theme.transitions.normal};

  &:hover {
    color: ${({ theme }) => theme.fontColors.primary};

    &:before {
      border-top-color: ${({ theme, open }) =>
        !open ? theme.borderColors.primary : 'transparent'};
      border-bottom-color: ${({ theme, open }) =>
        open ? theme.borderColors.primary : 'transparent'};
    }
  }

  &:before {
    content: '';
    width: 4px;
    height: 4px;
    border: 4px solid transparent;
    margin-right: 4px;
    border-top: ${({ theme, open }) =>
      !open ? `4px solid ${theme.fontColors.default}` : 0};
    border-bottom: ${({ theme, open }) =>
      open ? `4px solid ${theme.fontColors.default}` : 0};
  }
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
`;

const Root = styled.div<Props>`
  position: relative;
  width: 100%;
  overflow: hidden;
  margin: ${({ theme }) => `${theme.spaces.m} 0 ${theme.spaces.l}`};
  padding: ${({ theme }) => `${theme.spaces.xl} ${theme.spaces.xl}`};
  background-color: ${({ theme }) => theme.backgroundColors.default};

  ${Item} {
    &.h3 {
      display: ${({ open }) => (open ? 'block' : 'none')};
    }
  }
`;

export const Toc = Object.assign(Root, { Item, List, Title, Button });
